import { motion } from "framer-motion";
import { styled } from "@mui/system";

const LogoDot = styled(motion.span)(() => ({
  position: "relative",
  width: 10,
  height: 10,
  borderRadius: "999px",
  background: "#58A6FF", // your original blue
  display: "inline-block",
  boxShadow: "0 0 0 0 rgba(88, 166, 255, 0.35)", // soft base glow

  // subtle blue halo around the dot
  "&::after": {
    content: '""',
    position: "absolute",
    inset: -4, // slightly bigger than the dot
    borderRadius: "999px",
    background:
      "radial-gradient(circle, rgba(88,166,255,0.55), transparent 60%)",
    opacity: 0.8,
    zIndex: -1,
  },
}));

export default LogoDot;
